<script>
import { _request } from '@/helpers/_request.js'
import Parser from '@/helpers/_responseParser'

export default {
  name: 'RecipientService',
  methods: {
    getTransactionNexusSummary (Limit) {
      return _request('GetTransactionNexusSummary', { Limit }).then(Parser.toXml.bind(null, 'TransactionNexusSummaryResponse'))
    },
    getTransactionSummary (Limit, ListAllStatus) {
      return _request('GetTransactionSummary', { Limit, ListAllStatus }).then(Parser.toXml.bind(null, 'TransactionSummaryResponse'))
    },
    getTransactionDetails (TransactionNumber) {
      return _request('GetTransactionDetails', { TransactionNumber }).then(Parser.toXml.bind(null, 'TransactionDetailsResponse'))
    },
    checkTransactionLimits (TransactionType, Amount, RemittanceGatewayId) {
      return _request('CheckTransactionLimits', { TransactionList: [{ Currency: 'CAD', TransactionType, Amount, RemittanceGatewayId }] }).then(Parser.toXml.bind(null, 'CheckTransactionLimitsResponse'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/TransactionService.vue